export default "__VITE_ASSET__B3oyJnS5__"